import { getTokenFromCookies, url } from "../utils/configData";


const fetchAddCryptoWallet = async ({
  curr = "usdt",
  name,
  num,
  type = "trc20",
}) => {
  const end = `/wallets/crypto/create`;
  const token = getTokenFromCookies();
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
  const body = JSON.stringify({ curr, name, num, type });
  try {
    const response = await fetch(url + end, {
      method: "POST",
      credentials: "include",
      headers: headers,
      body: body,
    });
    if (response.ok) {
      const cryptoData = await response.json();
      return { curr, name, num, type, key: cryptoData.id, visib: 1 };
    } else {
      return null;
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }
};

const fetchAddBankWallet = async ({ type, bank_name, curr, iban, code, owner, country, city, address, zip_code }) => {
  const end = `/wallets/bank/create`;
  const token = getTokenFromCookies();
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
  const body = JSON.stringify({ type, bank_name, curr, iban: iban.toUpperCase(), code: code.toUpperCase(), owner, country , city, address, zip_code });
  try {
    const response = await fetch(url + end, {
      method: "POST",
      credentials: "include",
      headers: headers,
      body: body,
    });
    if (response.ok) {
      const bankData = await response.json();
      console.log(bankData, "walletsData");
      return {
        type,
        bank_name,
        curr,
        iban: iban.toUpperCase(),
        code: code.toUpperCase(),
        owner,
        key: bankData.id,
        visib: 1,
      };
    } else {
      return null;
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }
};

export {
  fetchAddCryptoWallet,
  fetchAddBankWallet,
};
